import { Component, Input } from "@angular/core";
import { IssueCardModel } from "../../../models/issue-card.model";

@Component({
  selector: 'app-issue-card',
  templateUrl: './issue-card.component.html',
  styleUrls: ['./issue-card.component.scss']
})
export class IssueCardComponent {

  @Input() issueCard: IssueCardModel



  public daysAgo(dateString: string): number {
    const date = new Date(dateString);
    const currentDate = new Date();
    const diffTime = Math.abs(currentDate.getTime() - date.getTime());
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
  }

}
